<template lang="pug">
v-app.Poppins
  DialogArteDivulgacao(ref="dialogArte")
  dialog-historico-alteracoes(ref="dialogHistorico")

  WarningSelect(v-show="!estabelecimentoSelecionado")

  v-container(grid-list-xl, fluid, v-if="estabelecimentoSelecionado")
    v-layout(row, wrap, align-center)
      v-flex
        .headline.font-weight-bold.voltar-titulo(@click="$router.push({ name: 'Marketing' })", style="cursor:pointer;display:inline-flex;align-items:center;gap:4px;")
          v-icon(size="20", color="rgba(0,0,0,0.87)") chevron_left
          span Campanha de Promoção
        .body-1.grey--text.text--darken-1 Promoções vinculadas ao seu estabelecimento

    //- ─── Insights de Desempenho das Promoções ─────────────────────────────────
    v-container(grid-list-xl, fluid).px-0.pb-2
      v-layout(row, wrap, align-center).mb-2
        v-flex(xs12)
          .insights-title.Poppins Desempenho das Promoções
          .insights-subtitle.Poppins Pedidos com promoção especial nos últimos 28 dias

      v-layout(row, wrap)
        v-flex.xs12.sm6.lg2dot4
          .kpi-card
            .kpi-card__icon-wrap.kpi-card__icon-wrap--green
              v-icon(style="color:#1d9a5a;font-size:22px") local_offer
            .kpi-card__label.Poppins Vendas com Promo
            .kpi-card__value--skeleton(v-if="loadingInsights")
            .kpi-card__value.Poppins(v-else) {{ kpisPromo.totalVendas | currency }}
            .kpi-card__sub.Poppins(v-if="!loadingInsights") {{ kpisPromo.qtdPedidos | number }} pedidos

        v-flex.xs12.sm6.lg2dot4
          .kpi-card
            .kpi-card__icon-wrap.kpi-card__icon-wrap--blue
              v-icon(style="color:#3060CA;font-size:22px") confirmation_number
            .kpi-card__label.Poppins Pedidos com Promo
            .kpi-card__value--skeleton(v-if="loadingInsights")
            .kpi-card__value.Poppins(v-else) {{ kpisPromo.qtdPedidos | number }}
            .kpi-card__sub.Poppins(v-if="!loadingInsights") no período

        v-flex.xs12.sm6.lg2dot4
          .kpi-card
            .kpi-card__icon-wrap.kpi-card__icon-wrap--purple
              v-icon(style="color:#6432b4;font-size:22px") person_add
            .kpi-card__label.Poppins Novos Clientes Atraídos
            .kpi-card__value--skeleton(v-if="loadingInsights")
            .kpi-card__value.Poppins(v-else) {{ kpisPromo.novosClientes | number }}
            .kpi-card__sub.Poppins(v-if="!loadingInsights") 1ª compra no estabelecimento

        v-flex.xs12.sm6.lg2dot4
          .kpi-card
            .kpi-card__icon-wrap.kpi-card__icon-wrap--blue
              v-icon(style="color:#3060CA;font-size:22px") people
            .kpi-card__label.Poppins
              span Pedidos Recorrentes
              v-icon.kpi-card__info(small, @click="dialogTipRecorrentes = true") info_outline
            .kpi-card__value--skeleton(v-if="loadingInsights")
            .kpi-card__value.Poppins(v-else) {{ kpisPromo.recorrentes | number }}
            .kpi-card__sub.Poppins(v-if="!loadingInsights") clientes que já compraram

        v-flex.xs12.sm6.lg2dot4
          .kpi-card
            .kpi-card__icon-wrap.kpi-card__icon-wrap--red
              v-icon(style="color:#FF4B4B;font-size:22px") redeem
            .kpi-card__label.Poppins Incentivo Bigou
            .kpi-card__value--skeleton(v-if="loadingInsights")
            .kpi-card__value.Poppins(v-else) {{ kpisPromo.totalIncentivo | currency }}
            .kpi-card__sub.Poppins(v-if="!loadingInsights") subsídio oferecido pelo Bigou

    v-divider.my-2

    v-layout.mt-3.mb-2(row, wrap, align-center)
      v-flex(xs12)
        .insights-title.Poppins Promoções Disponíveis
        .insights-subtitle.Poppins Itens com promoção especial vinculados ao seu estabelecimento

    v-container(grid-list-xl, fluid, v-if="bloqueioPromocao.ativo").px-0.pb-0.mt-2
      v-layout(row, wrap)
        v-flex(xs12)
          message-panel(
            type="danger",
            :title="bloqueioPromocao.motivo.titulo",
            :message="bloqueioPromocao.motivo.mensagem"
          )

    v-layout.mt-2.mb-2(row, wrap, v-if="!loading && promos.length")
      v-flex(xs12)
        .filtro-status
          button.filtro-chip.Poppins(
            v-for="chip in filtrosStatus",
            :key="chip.key",
            type="button",
            :class="[`filtro-chip--${chip.key}`, { 'filtro-chip--active': filtroStatus === chip.key }]",
            @click="filtroStatus = chip.key"
          )
            span.filtro-chip__label {{ chip.label }}
            span.filtro-chip__badge {{ chip.count }}

    .beneficios-banner(v-if="!loading && promos.length")
      .beneficios-banner__header
        v-icon(color="#1d9a5a", size="20") rocket_launch
        span.Poppins Ative promoções e receba
      .beneficios-banner__items
        .beneficio
          .beneficio__icon
            v-icon(color="#FF8C00", size="22") star
          .beneficio__content
            .beneficio__title.Poppins Destaque na tela de promoções
            .beneficio__desc.Poppins Seu item ganha posição privilegiada e aparece em primeiro lugar para os clientes
        .beneficio
          .beneficio__icon
            v-icon(color="#3060CA", size="22") notifications_active
          .beneficio__content
            .beneficio__title.Poppins Notificação push no app
            .beneficio__desc.Poppins Avisamos os clientes da sua promoção pela fila de notificações, com segmentação por perfil

    v-layout(row, wrap, v-if="loading")
      v-flex.text-xs-center
        v-progress-circular(:width="3", :size="40", color="primary", indeterminate)

    v-layout(row, wrap, v-else-if="!promos.length")
      v-flex.md12.text-xs-center.mt-5
        v-icon(size="64", color="grey lighten-1") local_offer
        .headline.font-weight-light.mt-3 Nenhuma promoção encontrada
        .body-1.grey--text.mt-1 Não há campanhas de promoção ativas vinculadas ao seu estabelecimento.

    template(v-else)
      v-layout(row, wrap)
        v-flex(xs12, md6, v-for="grupo in gruposVisiveis", :key="grupo.key")
          .campanha-container(:ref="'grupo-' + grupo.key")
            .campanha-header
              v-img.campanha-header__capa(
                v-if="grupo.imagem",
                :src="`${urlImagem}/campanhas/${grupo.imagem}`",
                :aspect-ratio="3"
              )
              .campanha-header__capa-ph(v-else)
                .campanha-header__capa-ph-content
                  v-icon(size="20", color="rgba(255,255,255,0.92)") rocket_launch
                  span.campanha-header__capa-ph-nome.Poppins {{ grupo.nome }}
              .grupo-title.Poppins
                span {{ grupo.nome }}
                span.grupo-title__badge {{ grupo.itens.length }}
              .grupo-subtitle.Poppins(v-if="grupo.descricao") {{ grupo.descricao }}

            .cardPromo-scroll
              v-card.cardPromo.br-10(
                v-for="promo in grupo.itens",
                :key="promo.id",
                :class="{ 'cardPromo--desativado': !isAtivoPromo(promo) }"
              )
                .cardPromo__media
                  v-img.cardPromo__img(
                    v-if="promo.imagem && !promo.imagemQuebrada",
                    :src="`${urlImagem}/item/${promo.imagem}`",
                    width="120",
                    height="132",
                    @error="onImagemErro(promo)"
                  )
                  .cardPromo__media-ph(v-else)
                    v-icon(size="30", color="#bdbdbd") fastfood
                  .cardPromo__novidade(v-if="isNovidade(promo)")
                    v-icon(size="12", color="#1D7D4A") auto_awesome
                    span Novidade

                .cardPromo__body
                  .cardPromo__col-main
                    .cardPromo__nome.text-truncate(:title="promo.nome") {{ promo.nome }}
                    .cardPromo__meta
                      .cardPromo__chips
                        span.chip(:class="isAtivoPromo(promo) ? 'chip--ativo' : 'chip--desativado'") {{ isAtivoPromo(promo) ? 'Ativo' : 'Desativado' }}
                      .cardPromo__publico-inline
                        v-icon(size="14", color="#6432b4") group
                        span {{ isSegmentada(promo) ? 'Público segmentado' : 'Público aberto' }}
                      .cardPromo__vigencia(v-if="promo.data_inicio || promo.data_fim")
                        v-icon(size="13", color="#888") event
                        span {{ formatDate(promo.data_inicio) }} — {{ formatDate(promo.data_fim) }}
                      .cardPromo__vigencia(v-if="promo.disponibilidade_diaria")
                        v-icon(size="13", color="#888") schedule
                        span {{ formatDiasSemana(promo.disponibilidade_diaria) }}
                    ultima-alteracao(
                      :log="ultimasAlteracoes[promo.id]",
                      @click="abrirHistorico(promo)"
                    )

                  .cardPromo__col-precos
                    .cardPromo__precos
                      span.preco-de__valor R$ {{ formatPrice(promo.preco) }}
                      span.preco-por__valor R$ {{ formatPrice(promo.preco_promocional) }}
                      span.desconto-tag -{{ promo.percentualDesconto }}%
                    .cardPromo__breakdown
                      .breakdown-item.breakdown-item--bigou(v-if="Number(promo.valorSubsidio) > 0")
                        span.label-mini Bigou paga
                        span.value-strong R$ {{ formatPrice(promo.valorSubsidio) }}
                        span.label-tiny ({{ promo.reembolso }}%)
                      .breakdown-item(v-else)
                        span.label-mini Subsídio
                        span.value-muted Sem
                      .breakdown-item
                        span.label-mini Você concede
                        span.value-strong R$ {{ formatPrice(descontoLojista(promo)) }}

                  .cardPromo__action
                    v-btn.btn-toggle.btn-toggle--imagem(
                      v-if="isAtivoPromo(promo) && !isSegmentada(promo)",
                      small,
                      flat,
                      @click="abrirArtePromocao(promo)"
                    )
                      v-icon.mr-1(small) image
                      | Imagem
                    v-btn.btn-toggle(
                      v-if="isAtivoPromo(promo)",
                      small,
                      flat,
                      :loading="promo.loadingToggle",
                      @click="pedirConfirmacaoToggle(promo, 'desativar')"
                    )
                      v-icon.mr-1(small) close
                      | Desativar
                    v-btn.btn-toggle.btn-toggle--ativar.white--text(
                      v-else,
                      small,
                      :loading="promo.loadingToggle || loadingPedidos28d",
                      :disabled="loadingPedidos28d",
                      @click="pedirConfirmacaoToggle(promo, 'ativar')"
                    )
                      v-icon.mr-1(small) check
                      | Ativar

  v-dialog(v-model="dialogConfirmacao.open", width="420", persistent)
    v-card.Poppins(style="border-radius:14px;")
      v-card-title.font-weight-semibold.Poppins(style="font-size:18px;") {{ dialogConfirmacaoTexto.titulo }}
      v-card-text.Poppins(style="font-size:14px;color:#5B5B5B;") {{ dialogConfirmacaoTexto.mensagem }}
      v-card-actions.Poppins
        v-spacer
        v-btn(flat, :disabled="dialogConfirmacao.loading", @click="fecharDialogConfirmacao") Fechar
        v-btn.white--text(
          :color="dialogConfirmacaoTexto.btnColor",
          depressed,
          :loading="dialogConfirmacao.loading",
          @click="confirmarAcaoStatus"
        ) {{ dialogConfirmacaoTexto.btnTexto }}

  v-dialog(v-model="dialogTipRecorrentes", width="380")
    v-card.Poppins(style="border-radius:14px;")
      v-card-title.font-weight-semibold.Poppins(style="font-size:16px;") Pedidos Recorrentes
      v-card-text.Poppins(style="font-size:14px;color:#5B5B5B;") Pedidos feitos por clientes que já pediram na sua loja
      v-card-actions.Poppins
        v-spacer
        v-btn(flat, color="primary", @click="dialogTipRecorrentes = false") Entendi

  v-dialog(v-model="dialogBloqueio", width="440")
    v-card.Poppins(style="border-radius:14px;", v-if="bloqueioPromocao.motivo")
      v-card-title.font-weight-semibold.Poppins(style="font-size:18px;") {{ bloqueioPromocao.motivo.titulo }}
      v-card-text.Poppins(style="font-size:14px;color:#5B5B5B;")
        p {{ bloqueioPromocao.motivo.mensagem }}
        p.mb-0
          b Como desbloquear:&nbsp;
          | {{ comoDesbloquear }}
      v-card-actions.Poppins
        v-btn.white--text(
          v-if="bloqueioPromocao.motivo.tipo === 'suspenso'",
          color="#B3261E",
          depressed,
          @click="abrirSuporte"
        )
          v-icon(left, small) support_agent
          | Falar com o Suporte
        v-spacer
        v-btn(flat, @click="dialogBloqueio = false") Fechar
</template>

<script>
import _ from 'lodash';
import WarningSelect from '@/components/WarningSelect';
import MessagePanel from '@/components/MessagePanel';
import DialogArteDivulgacao from '@/components/dialog/DialogArteDivulgacao';
import DialogHistoricoAlteracoes from '@/components/dialog/DialogHistoricoAlteracoes';
import UltimaAlteracao from '@/components/marketing/UltimaAlteracao';
import ArteDivulgacao from '@/util/arteDivulgacao';
import { calcularMetricasCancelamento, avaliarBloqueio } from '@/util/estabelecimentoBloqueio';
import { isAtivoPromo as isAtivoPromoUtil, isNovidadePromo } from '@/util/promocao';
import { ENTIDADE_ITEM, buscarUltimasAlteracoes } from '@/util/logAtivacao';
import { registrarContatoSuporte } from '@/util/suporte';

export default {
  name: 'CampanhaPromocao',
  components: {
    WarningSelect,
    MessagePanel,
    DialogArteDivulgacao,
    DialogHistoricoAlteracoes,
    UltimaAlteracao,
  },
  data() {
    return {
      loading: false,
      promos: [],
      ultimasAlteracoes: {},
      pedidosPromo: [],
      pedidos28d: [],
      loadingPedidos28d: false,
      loadingInsights: false,
      filtroStatus: 'desativado',
      dialogConfirmacao: {
        open: false,
        promo: null,
        acao: null,
        loading: false,
      },
      dialogTipRecorrentes: false,
      dialogBloqueio: false,
    }
  },
  computed: {
    estabelecimentoSelecionado() {
      return this.$root.estabelecimentoSelecionado;
    },
    urlImagem() {
      return process.env.VUE_APP_IMAGE_URL;
    },
    contagensEstado() {
      const ativo = this.promos.filter(p => this.isAtivoPromo(p)).length;
      return {
        todas: this.promos.length,
        ativo: ativo,
        desativado: this.promos.length - ativo,
      };
    },
    filtrosStatus() {
      const c = this.contagensEstado;
      return [
        { key: 'todas',      label: 'Todas',      count: c.todas },
        { key: 'ativo',      label: 'Ativo',      count: c.ativo },
        { key: 'desativado', label: 'Desativado', count: c.desativado },
      ];
    },
    gruposVisiveis() {
      const filtros = {
        ativo:      (p) => this.isAtivoPromo(p),
        desativado: (p) => !this.isAtivoPromo(p),
      };
      const filtroFn = filtros[this.filtroStatus];
      const lista = filtroFn ? this.promos.filter(filtroFn) : this.promos;
      const ordemStatus = [1, 3, 2];
      const grupos = _.groupBy(lista, (p) => p.campanha_promocao_id);
      return Object.keys(grupos)
        .map((campanhaId) => {
          const itens = _.sortBy(grupos[campanhaId], (p) => ordemStatus.indexOf(p.status));
          const ref = itens[0] || {};
          return {
            key: campanhaId,
            id: ref.campanha_promocao_id,
            nome: ref.campanha_nome,
            descricao: ref.campanha_descricao,
            imagem: ref.campanha_imagem,
            itens: itens,
          };
        })
        .filter((g) => g.itens && g.itens.length)
        .sort((a, b) => String(a.nome || '').localeCompare(String(b.nome || '')));
    },
    bloqueioPromocao() {
      const metricas = calcularMetricasCancelamento(this.pedidos28d);
      const result = avaliarBloqueio({
        estabelecimento: this.estabelecimentoSelecionado,
        metricas: metricas,
        contexto: 'promocao',
      });
      const motivo = (result.motivo && result.motivo.tipo !== 'sem_estabelecimento')
        ? result.motivo
        : null;
      return {
        ativo: !!motivo,
        contratoSuspenso: result.contratoSuspenso,
        bloqueadoPorCancelamento: result.bloqueadoPorCancelamento,
        motivo: motivo,
      };
    },
    comoDesbloquear() {
      const motivo = this.bloqueioPromocao.motivo;
      if (motivo && motivo.tipo === 'suspenso') {
        return 'entre em contato com o Suporte do Bigou para regularizar o contrato da loja.';
      }
      const faltam = (motivo && motivo.pedidosParaRegularizar) || 0;
      const plural = faltam === 1 ? 'pedido' : 'pedidos';
      return 'aceite ' + faltam + ' ' + plural + ' sem cancelar nenhum para regularizar.';
    },
    dialogConfirmacaoTexto() {
      const acao = this.dialogConfirmacao.acao;
      const promo = this.dialogConfirmacao.promo;
      const nome = promo && promo.nome ? promo.nome : '';
      if (acao === 'ativar') {
        return {
          titulo: 'Ativar promoção',
          mensagem: 'Ativar a promoção do item "' + nome + '"? Ela ficará visível para os clientes no app.',
          btnTexto: 'Ativar',
          btnColor: '#1d9a5a',
        };
      }
      return {
        titulo: 'Desativar promoção',
        mensagem: 'Desativar a promoção do item "' + nome + '"? Ela deixará de aparecer no app.',
        btnTexto: 'Desativar',
        btnColor: '#C0392B',
      };
    },
    kpisPromo() {
      const comPromo = this.pedidosPromo.filter(o => {
        if (o.status !== 1 && o.status !== 2) return false;
        return o.itens && o.itens.some(ip => ip.promocao_especial == 1);
      });
      const totalVendas = _.sumBy(comPromo, o => this.calcBruto(o));
      const qtdPedidos = comPromo.length;
      const novos = comPromo.filter(o => o.primeiro_estabelecimento || o.primeiro);
      const novosClientes = novos.length;
      const recorrentes = qtdPedidos - novosClientes;
      const totalIncentivo = _.sumBy(comPromo, o => o.reembolso_promocao || 0);
      return { totalVendas, qtdPedidos, novosClientes, recorrentes, totalIncentivo };
    },
  },
  created() {
    window.getApp.$on("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  beforeDestroy() {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
  },
  mounted() {
    this.onChangeEstabelecimento();
  },
  watch: {
    estabelecimentoSelecionado(estab) {
      if (estab && estab.cardapio_digital) {
        this.$router.replace({ name: 'Marketing' });
      }
    },
  },
  methods: {
    onChangeEstabelecimento() {
      if (this.estabelecimentoSelecionado && this.estabelecimentoSelecionado.cardapio_digital) {
        this.$router.replace({ name: 'Marketing' });
        return;
      }
      if (this.estabelecimentoSelecionado) {
        this.fetchPromos();
        this.fetchInsights();
        this.fetchPedidos28d();
        this.fetchUltimasAlteracoes();
      }
    },
    async fetchUltimasAlteracoes() {
      const vm = this;
      const lojaId = vm.estabelecimentoSelecionado && vm.estabelecimentoSelecionado.id;
      if (!lojaId) return;
      try {
        const ultimas = await buscarUltimasAlteracoes(vm.$axios, {
          entidade: ENTIDADE_ITEM,
          estabelecimentoId: lojaId,
        });
        if (vm.estabelecimentoSelecionado && vm.estabelecimentoSelecionado.id === lojaId) {
          vm.ultimasAlteracoes = ultimas;
        }
      } catch (e) {
        vm.ultimasAlteracoes = {};
      }
    },
    abrirHistorico(promo) {
      this.$refs.dialogHistorico.abrir({
        entidade: ENTIDADE_ITEM,
        entidade_id: promo.id,
        titulo: promo.nome,
        subtitulo: promo.campanha_nome,
        estabelecimento_id: this.estabelecimentoSelecionado.id,
      });
    },
    async fetchPedidos28d() {
      const vm = this;
      if (!vm.estabelecimentoSelecionado) return;
      vm.loadingPedidos28d = true;
      const hoje = vm.$dayjs();
      const dataInicio = hoje.subtract(28, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const dataFim = hoje.subtract(1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');
      try {
        const res = await vm.$axios.get('/pedido', {
          params: {
            estabelecimento_id: vm.estabelecimentoSelecionado.id,
            data_inicio: dataInicio,
            data_fim: dataFim,
            statusList: '0,1,2,3',
            orderDesc: 'data',
          },
        });
        vm.pedidos28d = res.data;
      } catch (e) {
        vm.pedidos28d = [];
      }
      vm.loadingPedidos28d = false;
    },
    calcBruto(o) {
      const comissaoReembolso = this.$dayjs(o.data).isAfter(this.$dayjs('2024-03-31 23:59:59'));
      const reembolso = comissaoReembolso ? (o.reembolso_promocao || 0) : 0;
      return o.estabelecimento_cupom == 1 ? o.total + reembolso : (o.total + (o.desconto || 0) + reembolso);
    },
    async fetchInsights() {
      const vm = this;
      if (!vm.estabelecimentoSelecionado) return;
      vm.loadingInsights = true;
      const hoje = vm.$dayjs();
      const dataInicio = hoje.subtract(28, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
      const dataFim = hoje.subtract(1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');
      try {
        const res = await vm.$axios.get('/pedido', {
          params: {
            estabelecimento_id: vm.estabelecimentoSelecionado.id,
            data_inicio: dataInicio,
            data_fim: dataFim,
            statusList: '1,2,3',
            promocional: 1,
            fields: 'itens',
            orderDesc: 'data',
          },
        });
        vm.pedidosPromo = res.data;
      } catch (e) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Erro ao carregar indicadores de promoções.' });
      }
      vm.loadingInsights = false;
    },
    async fetchPromos() {
      const vm = this;
      vm.loading = true;
      try {
        const { data } = await vm.$axios.get('/campanha/promocao', {
          params: { estabelecimento_id: vm.estabelecimentoSelecionado.id }
        });
        vm.promos = data.map(p => ({ ...p, loadingToggle: false, imagemQuebrada: false }));
        if (vm.filtroStatus === 'desativado' && vm.contagensEstado.desativado === 0) {
          vm.filtroStatus = 'todas';
        }
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Erro ao buscar promoções' });
      } finally {
        vm.loading = false;
      }
      vm.scrollParaCampanha();
    },
    // Deep link vindo da tela de Marketing: /delivery/marketing/campanhas?campanha=<id>
    // Mostra todas as promoções e rola até o grupo da campanha indicada.
    scrollParaCampanha() {
      const alvo = this.$route.query.campanha;
      if (!alvo) return;
      this.filtroStatus = 'todas';
      this.$nextTick(() => {
        const refs = this.$refs['grupo-' + alvo];
        const el = Array.isArray(refs) ? refs[0] : refs;
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    // Delegam para @/util/promocao — regra única compartilhada com Marketing.vue.
    isAtivoPromo(p) {
      return isAtivoPromoUtil(p);
    },
    isSegmentada(p) {
      return ArteDivulgacao.promocaoSegmentada(p);
    },
    isNovidade(p) {
      return isNovidadePromo(p);
    },
    pedirConfirmacaoToggle(promo, acao) {
      if (acao === 'ativar' && this.bloqueioPromocao.ativo) {
        this.dialogBloqueio = true;
        return;
      }
      this.dialogConfirmacao.promo = promo;
      this.dialogConfirmacao.acao = acao;
      this.dialogConfirmacao.loading = false;
      this.dialogConfirmacao.open = true;
    },
    fecharDialogConfirmacao() {
      this.dialogConfirmacao.open = false;
      this.dialogConfirmacao.promo = null;
      this.dialogConfirmacao.acao = null;
      this.dialogConfirmacao.loading = false;
    },
    abrirSuporte() {
      this.$firebase.logEvent('promocao_suporte_suspensao_clicked');
      registrarContatoSuporte('promocao_dialog_bloqueio', this.estabelecimentoSelecionado);
      const loja = this.estabelecimentoSelecionado;
      const nome = loja ? (loja.nome + ' | ' + loja.id) : '';
      const raw = String((this.$root.FIREBASE_REMOTE_CONFIG && this.$root.FIREBASE_REMOTE_CONFIG.WPP_SUPORTE) || '5532988929726').replace(/\D/g, '');
      const phone = raw.startsWith('55') ? raw : ('55' + raw);
      const texto = encodeURIComponent('Olá, gostaria de saber sobre a suspensão da loja ' + nome);
      window.open('https://api.whatsapp.com/send?phone=' + phone + '&text=' + texto, '_blank');
    },
    async confirmarAcaoStatus() {
      const promo = this.dialogConfirmacao.promo;
      const acao = this.dialogConfirmacao.acao;
      if (!promo || !acao) {
        return;
      }
      this.dialogConfirmacao.loading = true;
      await this.executarUpdateStatus(promo, acao);
      this.fecharDialogConfirmacao();
    },
    async executarUpdateStatus(promo, acao) {
      const vm = this;
      promo.loadingToggle = true;
      const body = acao === 'ativar'
        ? { item_catalogo_id: promo.id, estabelecimento_id: vm.estabelecimentoSelecionado.id, status: 2, ativo: 1 }
        : { item_catalogo_id: promo.id, estabelecimento_id: vm.estabelecimentoSelecionado.id, status: 3 };
      try {
        await vm.$axios.put('/campanha/promocao/item/status', body);
        if (acao === 'ativar') {
          vm.$set(promo, 'status', 2);
          vm.$set(promo, 'ativo', 1);
          // O backend reativa a categoria promocional junto com o item — sem isso
          // a promo seguiria contando como não ativa em isAtivoPromo.
          vm.$set(promo, 'categoria_ativo', 1);
        } else {
          vm.$set(promo, 'status', 3);
        }
        vm.$firebase.logEvent(acao === 'ativar' ? 'promotion_activated' : 'promotion_deactivated');
        const msg = acao === 'ativar' ? 'Promoção ativada!' : 'Promoção desativada!';
        window.getApp.$emit('APP_ALERT', { color: 'primary', text: msg });
        vm.$root.getPromocoes(vm.estabelecimentoSelecionado.id);
        vm.fetchUltimasAlteracoes();
        // Promoção segmentada não tem arte — nem sugere.
        if (acao === 'ativar' && !vm.isSegmentada(promo)) {
          vm.abrirArtePromocao(promo, true, 'ativacao');
        }
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: 'Erro ao alterar a promoção' });
      } finally {
        promo.loadingToggle = false;
      }
    },
    abrirArtePromocao(promo, recemAtivado, origem) {
      if (!promo) {
        return;
      }
      this.$refs.dialogArte.abrirPromocao({
        promo: promo,
        estabelecimento: this.estabelecimentoSelecionado || {},
        recemAtivado: !!recemAtivado,
        origem: origem || 'lista',
      });
    },
    onImagemErro(promo) {
      this.$set(promo, 'imagemQuebrada', true);
    },
    descontoLojista(p) {
      const desconto = Number(p.desconto) || 0;
      const subsidio = Number(p.valorSubsidio) || 0;
      const liquido = desconto - subsidio;
      return liquido > 0 ? liquido : 0;
    },
    formatPrice(value) {
      if (!value && value !== 0) return '-';
      return Number(value).toFixed(2).replace('.', ',');
    },
    formatDate(date) {
      if (!date) return '-';
      return this.$dayjs(date).format('DD/MM/YYYY');
    },
    formatDiasSemana(diasCsv) {
      if (!diasCsv) return 'Todos os dias';
      const dias = String(diasCsv).split(',').map(n => parseInt(n, 10)).filter(n => !isNaN(n)).sort((a, b) => a - b);
      if (!dias.length) return 'Todos os dias';
      if (dias.length === 7) return 'Todos os dias';
      if (dias.length === 5 && dias.join(',') === '1,2,3,4,5') return 'Dias úteis';
      if (dias.length === 2 && dias.join(',') === '0,6') return 'Fins de semana';
      const labels = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SÁB'];
      return dias.map(d => labels[d]).join(', ');
    },
  },
}
</script>

<style lang="scss" scoped>
// ─── Banner de benefícios ───────────────────────────────────────────────────
.beneficios-banner {
  background: linear-gradient(135deg, #F6FBF7 0%, #EEF6FF 100%);
  border: 1px solid #E1EDE5;
  border-radius: 14px;
  padding: 16px 20px;
  margin: 8px 0 20px;
  &__header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 700;
    color: #1d7d4a;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-bottom: 12px;
  }
  &__items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
}
.beneficio {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  &__icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 2px 6px rgba(0,0,0,0.06);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__content { flex: 1; }
  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    line-height: 1.3;
  }
  &__desc {
    font-size: 12.5px;
    color: #5b5b5b;
    line-height: 1.45;
    margin-top: 2px;
  }
}

// ─── Grupos de promoção ─────────────────────────────────────────────────────
// Container unificado por campanha (header + grade de promoções)
.campanha-container {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);   // consistente com .kpi-card
  height: 100%;                                  // 2 colunas com mesma altura
  @media (max-width: 600px) {
    padding: 14px;
  }
}

.campanha-header {
  // header do container: divisória fina e clara separando das promoções (espelha o mobile)
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid #EFEFEF;
  &__capa {
    width: 100%;
    border-radius: 12px;        // banner 3:1 (1200x400) preenchendo o container
    margin-bottom: 8px;
  }
  // Banner padrão (sem imagem): verde da paleta, formas minimalistas + nome da campanha
  &__capa-ph {
    position: relative;
    width: 100%;
    padding-top: 33.33%;        // mesma proporção 3:1 do banner
    border-radius: 12px;
    margin-bottom: 8px;
    overflow: hidden;
    background: linear-gradient(135deg, #1d9a5a 0%, #1d7d4a 100%);
    // formas minimalistas: círculos translúcidos
    &::before,
    &::after {
      content: '';
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.08);
    }
    &::before {
      width: 180px;
      height: 180px;
      top: -70px;
      right: -40px;
    }
    &::after {
      width: 120px;
      height: 120px;
      bottom: -55px;
      left: -30px;
      background: rgba(255, 255, 255, 0.06);
    }
  }
  &__capa-ph-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 0 18px;
    text-align: center;
  }
  &__capa-ph-nome {
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.2;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

// Lista vertical das promoções da campanha (com scroll quando passa do limite)
.cardPromo-scroll {
  // Define o card como contexto de container: o layout reage à largura real
  // da coluna (não do viewport), já que os cards vivem em v-flex(xs12, md6).
  container-type: inline-size;
  container-name: promoList;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  max-height: 360px;             // ~2,5 cards visíveis → indica o scroll vertical
  padding-right: 6px;
  scrollbar-width: thin;
  scrollbar-color: #d0d0d0 transparent;
  &::-webkit-scrollbar { width: 8px; }
  &::-webkit-scrollbar-thumb { background: #d0d0d0; border-radius: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
}
.grupo-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 18px;
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 8px;
    border-radius: 11px;
    background: #F0F0F0;
    color: #555;
    font-size: 11px;
    font-weight: 600;
  }
}
.grupo-subtitle {
  font-size: 13px;
  color: #6b6b6b;
  margin-top: 2px;
  line-height: 1.4;
}

// ─── Card de promoção ───────────────────────────────────────────────────────
// Layout base = empilhado (mobile-first). Também é o fallback em navegadores
// sem suporte a container query: nunca há sobreposição, só reorganização.
.cardPromo {
  width: 100%;
  flex: 0 0 auto;
  min-height: 132px;             // cresce conforme o conteúdo quando empilhado
  border: 1.5px solid #ececec;
  border-radius: 10px;
  transition: box-shadow 0.2s ease;
  display: flex;
  align-items: stretch;
  overflow: hidden;
  &:hover { box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
  &--desativado { opacity: 0.85; }

  // Mídia: imagem do item ou placeholder (sempre à esquerda)
  &__media {
    position: relative;
    flex: 0 0 96px;
    width: 96px;
    background: #f4f4f4;
  }
  // preenche a coluna de mídia (ignora width/height inline do v-img) em ambos os modos
  &__img {
    width: 100% !important;
    height: 100% !important;
  }
  &__media-ph {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ECECEC;
  }
  &__novidade {
    position: absolute;
    top: 8px;
    left: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
    background: rgba(255, 255, 255, 0.92);
    color: #1D7D4A;
    font-size: 10.5px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 9px;
  }

  // Corpo: empilha nome → preços/subsídio → ação. No modo não-mobile (ver
  // @container) preços e subsídio passam a duas colunas lado a lado.
  &__body {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px 14px;
  }
  &__col-main {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  &__col-precos {
    min-width: 0;
    display: flex;
    flex-direction: column;   // empilhado no base (mobile); vira row no @container
    gap: 6px;
  }

  &__nome {
    font-size: 15px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.2;
  }
  // Faixa horizontal com status + público + vigência (quebra quando aperta)
  &__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px 14px;
    min-width: 0;
  }
  &__chips { display: flex; gap: 6px; }
  &__publico-inline {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    color: #3a1d6b;
    font-weight: 500;
    min-width: 0;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  &__vigencia {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 11.5px;
    color: #777;
    min-width: 0;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &__precos {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 6px 8px;
    .preco-de__valor {
      font-size: 12px;
      color: #999;
      text-decoration: line-through;
      font-weight: 500;
    }
    .preco-por__valor {
      font-size: 18px;
      font-weight: 700;
      color: #1d9a5a;
      line-height: 1;
    }
    .desconto-tag {
      background: #FFD600;
      color: #1a1a1a;
      font-weight: 700;
      font-size: 11px;
      padding: 2px 8px;
      border-radius: 6px;
    }
  }
  // Subsídio/desconto numa linha abaixo do preço, divididos em duas colunas
  // iguais. A fonte escala com a largura real do card (cqi) para caber sem quebrar.
  &__breakdown {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: baseline;
    gap: 0 12px;
    .label-mini, .label-tiny { font-size: clamp(7.5px, 2cqi, 10px); }
    .value-strong { font-size: clamp(10px, 2.8cqi, 14px); }
    .breakdown-item {
      flex: 1 1 0;             // duas colunas de largura igual
      min-width: 0;
      display: flex;
      align-items: baseline;
      gap: 4px;
      white-space: nowrap;
      .label-mini { margin-bottom: 0; }
      &--bigou {
        .label-mini, .value-strong, .label-tiny { color: #1d7d4a; }
      }
    }
  }

  // Última linha do card: botão ancorado no rodapé, sem ocupar espaço lateral
  &__action {
    flex: 0 0 auto;
    margin-top: auto;          // empurra para o rodapé quando sobra altura
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    padding-top: 6px;
  }
}

// ─── Não-mobile (tablet/desktop): nome/status aproveitam a faixa horizontal e a
// imagem fica maior. Preço e subsídio/desconto seguem empilhados (subsídio numa
// linha abaixo do preço). Abaixo de 430px (celular) a imagem fica mais compacta.
// Mede a largura real do container (.cardPromo-scroll), não do viewport.
@container promoList (min-width: 430px) {
  .cardPromo__media {
    flex: 0 0 120px;
    width: 120px;
  }
}

// ─── Tipografia compartilhada dos cards ─────────────────────────────────────
.label-mini {
  font-size: 10px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 2px;
}
.label-tiny {
  font-size: 10px;
  color: #999;
  margin-top: 2px;
}
.value-mini {
  font-size: 12px;
  color: #333;
  font-weight: 500;
}
.value-strong {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
}
.value-muted {
  font-size: 13px;
  color: #aaa;
  font-style: italic;
}

// ─── Chips suaves ───────────────────────────────────────────────────────────
.chip {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 6px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 1.4;
  text-transform: uppercase;
  &--ativo      { background: #E6F7EE; color: #1d7d4a; }
  &--desativado { background: #F0F0F0; color: #757575; }
}

// ─── Botão de ação ──────────────────────────────────────────────────────────
.btn-toggle {
  border-radius: 8px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  margin: 0 !important;
  color: #C0392B !important;
  &--ativar {
    background: #1d9a5a !important;
    color: #fff !important;
    box-shadow: 0 2px 8px rgba(29, 154, 90, 0.25);
  }
  &--imagem {
    color: #3A3A3A !important;
  }
}

// ─── Insights ───────────────────────────────────────────────────────────────
.insights-title {
  font-size: 20px;
  font-weight: 500;
  color: #1a1a1a;
}
.insights-subtitle {
  font-size: 13px;
  color: #888;
  margin-top: 2px;
}

// ─── Filtro de status ───────────────────────────────────────────────────────
.filtro-status {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.filtro-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1.5px solid #e0e0e0;
  background: #fff;
  color: #555;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  font-family: 'Poppins', 'Roboto', sans-serif;
  transition: all 0.2s;
  &:hover { filter: brightness(0.97); }
  &__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 18px;
    padding: 0 6px;
    border-radius: 10px;
    background: #ECECEC;
    color: #666;
    font-size: 11px;
    font-weight: 700;
  }
  &--active {
    color: #fff !important;
    font-weight: 600;
    .filtro-chip__badge { background: rgba(255,255,255,0.28); color: #fff; }
  }
  &--todas.filtro-chip--active      { background: #32373B; border-color: #32373B; }
  &--ativo.filtro-chip--active      { background: #1D7D4A; border-color: #1D7D4A; }
  &--desativado.filtro-chip--active { background: #888;    border-color: #888;    }
}

// ─── KPI Cards ──────────────────────────────────────────────────────────────
.kpi-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  height: 100%;
}
.kpi-card__icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  &--green  { background: rgba(29,154,90,0.12); }
  &--blue   { background: rgba(48,96,202,0.12); }
  &--purple { background: rgba(100,50,180,0.12); }
  &--red    { background: rgba(255,75,75,0.12); }
}
.kpi-card__label {
  font-size: 11px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.kpi-card__info {
  font-size: 14px !important;
  color: #bbb;
  cursor: pointer;
}
.kpi-card__value {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.2;
}
.kpi-card__value--skeleton {
  height: 28px;
  width: 80%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
  border-radius: 8px;
  margin: 4px 0;
}
@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
.kpi-card__sub {
  font-size: 12px;
  color: #aaa;
  margin-top: 4px;
}

// ─── 5-column layout ────────────────────────────────────────────────────────
.lg2dot4 {
  flex: 0 0 20%;
  max-width: 20%;
}
@media (max-width: 1264px) { .lg2dot4 { flex: 0 0 50%; max-width: 50%; } }
@media (max-width: 600px)  { .lg2dot4 { flex: 0 0 100%; max-width: 100%; } }
</style>
